import React from 'react';
import { Link } from 'react-router-dom';
import SellWiseLogo from '../assets/sellwise-logo.png';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaLinkedin, FaTwitter, FaInstagram, FaFacebook } from 'react-icons/fa';


const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-container">
          <div className="footer-about">
            <div className="footer-logo">
              <img src={SellWiseLogo} alt="SellWise Logo" height="30" />
            
            </div>
            <p>Empowering FMCG distributors with cutting-edge SaaS solutions to optimize operations and drive growth.</p>
            <div className="social-links">
                          <a href="https://www.facebook.com/profile.php?id=61579591531789" className="social-link-footer"><FaFacebook /></a>
                          <a href="#" className="social-link-footer"><FaLinkedin /></a>
                          <a href="https://x.com/SellWise360" className="social-link-footer"><FaTwitter /></a>
                          <a href="https://www.instagram.com/sellwise360" className="social-link-footer"><FaInstagram /></a>
            </div>
          </div>
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href='/privacypolicy'>Privacy Policy</a></li>
              <li><a href='/tutorial'>Tutorial Library</a></li>
              <li><Link to="#features">Features</Link></li>
              <li><Link to="#how-it-works">How It Works</Link></li>
              {/* <li><Link to="#clients">Clients</Link></li> */}
              <li><Link to="#contact">Contact</Link></li>
              
            </ul>
          </div>
          <div className="footer-links">
            <h3>Products</h3>
            <ul>
              <li><Link to="#">DMS Web Platform</Link></li>
              <li><Link to="#">MSP Mobile App</Link></li>
              <li><Link to="#">Retailer Portal</Link></li>
              <li><Link to="#">Analytics Dashboard</Link></li>
              <li><Link to="#">Route Optimization</Link></li>
            </ul>
          </div>
          <div className="footer-newsletter">
            <h3>Newsletter</h3>
            <p>Subscribe to get updates on new features and industry insights.</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Your Email" />
              <button type="submit">→</button>
            </form>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SellWise360. All Rights Reserved. | <Link to="#">Privacy Policy</Link> | <Link to="#">Terms of Service</Link></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;